import React from "react";
import classes from "./Profile.module.css";
import image from "./Person_icon_BLACK-01.svg.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ManageApiKey from "./ManageApiKey";
import { roleType } from "../../Utils/constant";
import urls from "../../Utils/urls";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";
import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { lenderAchInformationProfilePageArr } from "../LenderOnboarding/LenderACHInformation/LenderAchConstants";
import {
  BlurWrapperWithSpan,
  LiHandleButton,
  LoadingButton,
  SpinnerBlock,
} from "../../Utils/CustomComponent";
import { isNaN } from "lodash";
import { useAbortController } from "../../hooks/useAbortController";
import AuthenticationPopup from "../Borrowers/BankAccountACHPayments/AuthenticationPopup";
import { updateACHFormSchema } from "../../Utils/formOptions";
import ProfileForBorrower from "./ProfileForBorrower";
import FormBox from "../../components/FormBox/FormBox";
import UserDetailsProfile from "./UserDetailsProfile";

function Profile() {
  const { signal } = useAbortController();
  const navigate = useNavigate();
  const userDetails = JSON.parse(localStorage.getItem("accessed_user"));
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const selectedRoleLabel = useSelector(
    (state) => state.account.selectedRole.label
  );
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  // const selectedAccount = JSON.parse(localStorage.getItem("user-details"));
  const roleOptions = useSelector((state) => state.account.roleOptions);
  const [routingDetails, setRoutingDetails] = useState({});
  const [canEdit, setCanEdit] = useState(false);
  const [otpPopup, setOtpPopup] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const jsonId = "161";
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "all", ...updateACHFormSchema });
  const [activeTab, setActiveTab] = useState(0);
  const tinType = watch("TINType");
  const tinVal = watch("unmaskedTIN");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const filteredAccount = selectedAccount?.label?.split(" - ")?.[1];
        const res = await axios.get(
          urls.profile.getLenderAchInformation(filteredAccount?.trim(" ")),
          { signal },
        );
        const data = res.data[0][0];
        if (res.data[0]?.length) {
          Object.keys(data)?.forEach((key) => {
            setValue(key, data[key]);
          });
        } else {
          lenderAchInformationProfilePageArr()[0]?.arr?.map((el) =>
            el?.arr?.forEach((item) => setValue(item?.field, undefined)),
          );

          lenderAchInformationProfilePageArr()[1]?.arr?.map((el) =>
            el?.arr?.forEach((item) => setValue(item?.field, undefined)),
          );
        }
      } catch (error) {
        console.error("Error fetching data:", error);

        lenderAchInformationProfilePageArr[0]?.arr?.map((el) =>
          el?.arr?.forEach((item) => setValue(item?.field, undefined)),
        );

        lenderAchInformationProfilePageArr[2]?.arr?.map((el) =>
          el?.arr?.forEach((item) => setValue(item?.field, undefined)),
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setValue, jsonId, selectedAccount?.label]);
  const routingNumber = watch("ACH_RoutingNumber");
  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      const getData = await axios.get(
        urls.borrower.getRoutingNumberValidation(routingNumber),
        { signal }
      );
      setRoutingDetails(getData.data);
      return getData.data;
    };
    if (
      routingNumber &&
      routingNumber?.length === 9 &&
      !isNaN(Number(routingNumber))
    ) {
      handleRoutingNumberValidation();
    }
  }, [routingNumber]);

  useEffect(() => {
    if (isAuthenticated) {
      setCanEdit(true);
    }
  }, [isAuthenticated]);

  const onSubmit = async (data) => {
    const id = toast.loading("Form Submission Pending");
    try {
      const data2 = {
        OPERATION: "UPDATE",
        USERNAME: selectedAccount.username,
        general: {
          name: data.FullName,
          salutation: data.Salutation,
          firstName: data.FirstName,
          lastName: data.LastName,
          middleInitial: data.MI,
          street: data.Street,
          city: data.City,
          zipCode: data.ZipCode,
          email: data.EmailAddress,
          homePhone: data.PhoneHome,
          workPhone: data.PhoneWork,
          mobilePhone: data.PhoneCell,
          faxNumber: data.PhoneFax,
          account: data.Account,
          // taxIdentificationNumber: data.taxIdentificationNumber,
          birthday: data.Birthday,
          email_print_delivery: data.email_print_delivery ? 1 : 0,
          email_email_delivery: data.email_email_delivery ? 1 : 0,
          email_textMessage_delivery: data.email_textMessage_delivery ? 1 : 0,
          taxReporting: data.taxReporting ? 1 : 0,
          printRolodexCards: data.printRolodexCards ? 1 : 0,
          bankName: data.ACH_BankName,
          bankAddress: data.ACH_BankAddress,
          routingNumber: data.ACH_RoutingNumber,
          accountNumber: data.ACH_AccountNumber,
          individualId: data.ACH_IndividualId,
          individualName: data.ACH_IndividualName,
          sendPrintedNotification: data.sendPrintedNotification ? 1 : 0,
          sendEmailNotification: data.sendEmailNotification ? 1 : 0,
          accountType: data.ACH_AccountType,
          serviceStatus: data.ACH_ServiceStatus,
          lenderCode: data.Code,
          categories: data.Categories,
          sendCheckToPayeeMessage: data.sendCheckToPayeeMessage,
          sendCheckToPayeeCheckbox: data.Send1099 ? 1 : 0,
          institutionalLender: data.Institutional ? 1 : 0,
          loanTypes_fixed: data.LoanType_Fixed ? 1 : 0,
          loanTypes_adjustable: data.LoanType_Adjustable ? 1 : 0,
          methodology: data.methodology,
          counselor: data.Counselor,
          state: data.State,
          taxIdType: data.TINType,
          taxIdentificationNumber: tinVal,
          // emailFormat: data.EmailFormat,
        },
        details: {
          name: data.FullName,
          salutation: data.Salutation,
          firstName: data.FirstName,
          lastName: data.LastName,
          middleInitial: data.MI,
          street: data.Street,
          city: data.City,
          zipCode: data.ZipCode,
          email: data.EmailAddress,
          homePhone: data.PhoneHome,
          workPhone: data.PhoneWork,
          mobilePhone: data.PhoneCell,
          faxNumber: data.PhoneFax,
          account: data.Account,
          taxIdentificationNumber: data.taxIdentificationNumber,
          birthday: data.Birthday,
          email_print_delivery: data.email_print_delivery ? 1 : 0,
          email_email_delivery: data.email_email_delivery ? 1 : 0,
          email_textMessage_delivery: data.email_textMessage_delivery ? 1 : 0,
          taxReporting: data.taxReporting ? 1 : 0,
          printRolodexCards: data.printRolodexCards ? 1 : 0,
          bankName: data.ACH_BankName,
          bankAddress: data.ACH_BankAddress,
          routingNumber: data.ACH_RoutingNumber,
          accountNumber: data.ACH_AccountNumber,
          individualId: data.ACH_IndividualId,
          individualName: data.ACH_IndividualName,
          sendPrintedNotification: data.sendPrintedNotification ? 1 : 0,
          sendEmailNotification: data.sendEmailNotification ? 1 : 0,
          accountType: data.ACH_AccountType,
          serviceStatus: data.ACH_ServiceStatus,
          lenderCode: data.Code,
          categories: data.Categories,
          sendCheckToPayeeMessage: data.sendCheckToPayeeMessage,
          sendCheckToPayeeCheckbox: data.Send1099 ? 1 : 0,
          institutionalLender: data.Institutional ? 1 : 0,
          loanTypes_fixed: data.LoanType_Fixed ? 1 : 0,
          loanTypes_adjustable: data.LoanType_Adjustable ? 1 : 0,
          methodology: data.methodology,
          counselor: data.Counselor,
          state: data.State,
          taxIdType: data.TINType,
          // emailFormat: data.EmailFormat,
        },
        ach: {
          name: data.FullName,
          salutation: data.Salutation,
          firstName: data.FirstName,
          lastName: data.LastName,
          middleInitial: data.MI,
          street: data.Street,
          city: data.City,
          zipCode: data.ZipCode,
          email: data.EmailAddress,
          homePhone: data.PhoneHome,
          workPhone: data.PhoneWork,
          mobilePhone: data.PhoneCell,
          faxNumber: data.PhoneFax,
          account: data.Account,
          taxIdentificationNumber: data.taxIdentificationNumber,
          birthday: data.Birthday,
          email_print_delivery: data.email_print_delivery ? 1 : 0,
          email_email_delivery: data.email_email_delivery ? 1 : 0,
          email_textMessage_delivery: data.email_textMessage_delivery ? 1 : 0,
          taxReporting: data.taxReporting ? 1 : 0,
          printRolodexCards: data.printRolodexCards ? 1 : 0,
          bankName: data.ACH_BankName,
          bankAddress: data.ACH_BankAddress,
          routingNumber: data.ACH_RoutingNumber,
          accountNumber: data.ACH_AccountNumber,
          individualId: data.ACH_IndividualId,
          individualName: data.ACH_IndividualName,
          sendPrintedNotification: data.sendPrintedNotification ? 1 : 0,
          sendEmailNotification: data.sendEmailNotification ? 1 : 0,
          accountType: data.ACH_AccountType,
          serviceStatus: data.ACH_ServiceStatus,
          lenderCode: data.Code,
          categories: data.Categories,
          sendCheckToPayeeMessage: data.sendCheckToPayeeMessage,
          sendCheckToPayeeCheckbox: data.Send1099 ? 1 : 0,
          institutionalLender: data.Institutional ? 1 : 0,
          loanTypes_fixed: data.LoanType_Fixed ? 1 : 0,
          loanTypes_adjustable: data.LoanType_Adjustable ? 1 : 0,
          methodology: data.methodology,
          counselor: data.Counselor,
          state: data.State,
          taxIdType: data.TINType,
          // emailFormat: data.EmailFormat,
        },
      };
      const res = await axios.post(urls.profile.updateLenderOnboard, data2);
      if (res.status === 200 || res.statusText === "OK") {
        toast.update(id, {
          render: "Form Submitted Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 1000);
    }
  };

  function authenticate() {
    setOtpPopup(true);
  }

  return (
    <div
      style={{
        backgroundColor: "#fff",
        // padding: "34px 46px",
        borderRadius: "8px",
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center"
        style={{
          backgroundColor: "#FF8057",
          padding: "31px 26.2px 27.5px 35px",
          borderRadius: "8px 8px 0 0",
          height: "126px",
          position: "relative",
        }}
      >
        <span className="d-none">
          <img src={image} alt="" className={classes.image} />
        </span>
        <div className="d-flex align-self-end" style={{ gap: "32px" }}>
          <h5>Profile</h5>
        </div>
        <div className="d-flex align-self-end" style={{ gap: "32px" }}>
          <button
            className={classes.button}
            onClick={() => navigate("/manage-account/change-password")}
          >
            Change Password
          </button>
        </div>
      </div>
      <div className="p-4">
        {/* <BlurWrapperWithSpan>
          <h6 className={classes.h6}>{userDetails.email.split("@")[0]}</h6>
        </BlurWrapperWithSpan>
        <p style={{ color: "#393F46" }}>
          <span className="fw-bolder">Roles available:</span>
        </p>
        <ul>
          {roleOptions?.map((role, index) => (
            <li key={index} className="ms-5">
              {role.label}
            </li>
          ))}
        </ul>

        <p className={classes.personalDetails}>
          <span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.584 15.7708C12.8479 15.7708 11.1257 15.3472 9.41732 14.5C7.70898 13.6528 6.17079 12.5486 4.80274 11.1875C3.43468 9.82639 2.32704 8.2882 1.47982 6.57292C0.632596 4.85764 0.208984 3.13889 0.208984 1.41667C0.208984 1.06944 0.32704 0.777778 0.563151 0.541667C0.799262 0.305556 1.08398 0.1875 1.41732 0.1875H4.33398C4.66732 0.1875 4.94162 0.28125 5.1569 0.46875C5.37218 0.65625 5.51454 0.916667 5.58399 1.25L6.14648 3.6875C6.20204 3.97917 6.19857 4.23958 6.13607 4.46875C6.07357 4.69792 5.95899 4.88889 5.79232 5.04167L3.64648 7.0625C4.3826 8.25695 5.18815 9.2882 6.06315 10.1563C6.93815 11.0243 7.92426 11.7569 9.02149 12.3542L11.0632 10.2708C11.2576 10.0625 11.4763 9.92014 11.7194 9.84375C11.9625 9.76736 12.2229 9.76389 12.5007 9.83333L14.7298 10.3542C15.0632 10.4375 15.3236 10.5938 15.5111 10.8229C15.6986 11.0521 15.7923 11.3333 15.7923 11.6667V14.5417C15.7923 14.8889 15.6743 15.1806 15.4382 15.4167C15.202 15.6528 14.9173 15.7708 14.584 15.7708ZM2.83398 5.60417L4.50065 3.97917L4.04232 1.85417H1.87565C1.86176 2.35417 1.93121 2.90625 2.08398 3.51042C2.23676 4.11458 2.48676 4.8125 2.83398 5.60417ZM14.1257 14.1042V11.9167L12.1673 11.4792L10.5423 13.1875C11.0701 13.4375 11.65 13.6424 12.2819 13.8021C12.9138 13.9618 13.5284 14.0625 14.1257 14.1042Z"
                fill="#FF8057"
              />
            </svg>
          </span>
          <BlurWrapperWithSpan>{userDetails.email}</BlurWrapperWithSpan>
        </p> */}
        <UserDetailsProfile />

        {(selectedRole === roleType.broker ||
          selectedRole === roleType.loanLinQAdministrator) &&
        selectedRoleLabel !== "Borrower" ? (
          <ManageApiKey />
        ) : null}
        {selectedRole === "L" ? (
          <div>
            <div
              className="d-flex"
              style={{ justifyContent: "space-between", alignItems: "end" }}
            >
              <h4 className="mt-5 pt-5">Update Lender ACH Information</h4>
              <div className="d-flex justify-content-center align-items-center mt-5">
                <Button
                  type="button"
                  className="me-2"
                  onClick={() => authenticate()}
                >
                  Edit
                </Button>
              </div>
            </div>
            <div className="loan-details lender-ach-form">
              <div className="pt-3">
                <ul className="nav nav-tabs">
                  {tabButtons.map((data, index) => (
                    <LiHandleButton
                      key={index}
                      activeTab={activeTab}
                      setActiveTab={setActiveTab}
                      label={data.label}
                      value={index}
                      handleBtnClick={setActiveTab}
                    />
                  ))}
                </ul>
              </div>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {lenderAchInformationProfilePageArr(canEdit, tinType).map(
                  (data, index) =>
                    activeTab === index && (
                      <>
                        {loading ? (
                          <div className="row">
                            <SpinnerBlock height={"10vh"} />
                          </div>
                        ) : (
                          <>
                            {routingDetails?.customer_name && index === 1 && (
                              <div style={{ color: "green" }}>
                                {routingDetails?.customer_name} -{" "}
                                {routingDetails?.city}, {routingDetails?.state}{" "}
                                {routingDetails?.zip}{" "}
                              </div>
                            )}
                            <MultipleFormBoxComp
                              key={index}
                              register={register}
                              watch={watch}
                              setValue={setValue}
                              options={data.arr}
                              errors={errors}
                            />
                          </>
                        )}
                      </>
                    ),
                )}
                <div className="col-sm-12 d-flex justify-content-between">
                  {activeTab > 0 && (
                    <Button
                      onClick={() => setActiveTab(activeTab - 1)}
                      className="me-2"
                    >
                      Back
                    </Button>
                  )}
                  {activeTab < 1 && (
                    <Button
                      onClick={() => setActiveTab(activeTab + 1)}
                      className="me-2"
                    >
                      Next
                    </Button>
                  )}
                  {activeTab === 1 && (
                    <OverlayTrigger
                      key={"lenderAch"}
                      trigger={"hover"}
                      placement={"left"}
                      overlay={
                        !canEdit ? (
                          <Tooltip id={`tooltip-${"lenderAch"}`}>
                            Click 'Edit' to complete or modify the form.
                          </Tooltip>
                        ) : (
                          <></>
                        )
                      }
                    >
                      <div
                        style={{
                          cursor: !canEdit ? "not-allowed" : "pointer",
                        }}
                      >
                        <Button
                          type="submit"
                          className="me-2"
                          disabled={!canEdit}
                        >
                          Submit
                        </Button>
                      </div>
                    </OverlayTrigger>
                  )}
                </div>
              </div>
            </form>
          </div>
        ) : selectedRoleLabel === "Borrower" ? (
          <ProfileForBorrower tinType={tinType} />
        ) : null}
      </div>
      <AuthenticationPopup
        otpPopup={otpPopup}
        setOtpPopup={setOtpPopup}
        setIsAuthenticated={setIsAuthenticated}
        show5pmMessage={false}
      />
    </div>
  );
}

export default Profile;

const tabButtons = [
  { label: <p>General</p> },
  // { label: <p>Details</p> },
  { label: <p>ACH</p> },
];
